import { createFileRoute } from "@tanstack/react-router";
import HighFunctioningDepression from "@/pages/articles/HighFunctioningDepression";
export const Route = createFileRoute(
  "/high-functioning-depression-when-holding-it-together-is-the-problem",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "High-Functioning Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "High-functioning depression hides behind success. Learn the signs and how TMS, SAINT TMS, and therapy can help in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "High-Functioning Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "High-functioning depression hides behind success. Learn the signs and how TMS, SAINT TMS, and therapy can help in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/high-functioning-depression-when-holding-it-together-is-the-problem",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/high-functioning-depression-when-holding-it-together-is-the-problem",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HighFunctioningDepression />;
}
